import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Spinner, Toast, ToastBody, ToastHeader, Card, CardBody } from 'reactstrap';
import { addPosition, fetchPendingOrders, removePosition } from '../../rtk/slices/getPendingOrderSlice/getPendingOrderSlice';
import { cancelPendingOrder } from '../../rtk/slices/pendingOrderSlice/cancelPendingOrderSlice';
import { updatePendingOrder } from '../../rtk/slices/pendingOrderSlice/updatePendingOrderSlice';
import { subscribeToOrderChannel, unsubscribeFromOrderChannel } from '../../utils/pusher-2';

const PendingOrders = () => {
    const dispatch = useDispatch();
    const { pendingOrders, loading, error } = useSelector((state) => state.getPendingOrders);
    const symbols = useSelector((state) => state.trading.symbols);
    const successMessage = useSelector((state) => state.cancelPendingOrder.successMessage);
    const errorMessage = useSelector((state) => state.cancelPendingOrder.errorMessage);
    const tradeUpdationSuccessMessage = useSelector((state) => state.updatePendingOrder.successMessage);

    const [editingField, setEditingField] = useState(null); // To track which field is being edited
    const [editValue, setEditValue] = useState('');
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastType, setToastType] = useState('');




    // Function to handle editing start
    const handleEditStart = (positionId, field, currentPrice) => {
        setEditingField({ positionId, field });
        setEditValue(currentPrice);  // Set current price as the editable value
    };

    // Function to handle update SL
    const handleUpdateSL = (positionid, newSL) => {
        const user = JSON.parse(localStorage.getItem('user'));
        const accountNum = user ? user.account : null;
        if (accountNum) {
            dispatch(updatePendingOrder({
                account: accountNum,
                order_id: positionid,
                sl: newSL
            }))
                .then(() => {
                    dispatch(fetchPendingOrders(accountNum));
                });
        }

        console.log(`Updating SL for position ${positionid} to ${newSL}`);
        setEditingField(null); // Close the edit mode
    };

    // Function to handle update TP
    const handleUpdateTP = (positionId, newTP) => {
        const user = JSON.parse(localStorage.getItem('user'));
        const accountNum = user ? user.account : null;
        if (accountNum) {
            dispatch(updatePendingOrder({
                account: accountNum,
                order_id: positionId,
                tp: newTP
            }))
                .then(() => {
                    dispatch(fetchPendingOrders(accountNum));
                });
        }
        console.log(`Updating TP for position ${positionId} to ${newTP}`);
        setEditingField(null); // Close the edit mode
    };
    const handleUpdatePrice = (positionId, newPrice) => {

        const user = JSON.parse(localStorage.getItem('user'));
        const accountNum = user ? user.account : null;
        if (accountNum) {
            dispatch(updatePendingOrder({
                account: accountNum,
                order_id: positionId,
                ordre_price: newPrice
            }))
                .then(() => {
                    dispatch(fetchPendingOrders(accountNum));
                });
        }

        console.log(`Updating Price for position ${positionId} to ${newPrice}`);
        setEditingField(null); // Close the edit mode
    };

    // Function to handle cancel edit
    const handleCancelEdit = () => {
        setEditingField(null); // Close the edit mode
        setEditValue(''); // Clear the edit value
    };

    const handleOrderCancel = (order) => {
        const user = JSON.parse(localStorage.getItem('user'));
        const accountNum = user ? user.account : null;

        console.log(`Order for order number ${order.positionid} for ${order.symbol} has been closed with no fullfillment.`);

        if (accountNum) {
            dispatch(cancelPendingOrder({
                account: accountNum,
                order_id: order.positionid,
            }))
                .then(() => {
                    dispatch(fetchPendingOrders(accountNum));
                });
        }
    };

    // useEffect(() => {
    //     const user = JSON.parse(localStorage.getItem('user'));
    //     const accountNum = user ? user.account : null;

    //     if (accountNum) {
    //         dispatch(fetchPendingOrders(accountNum)); // Fetch initial data

    //         subscribeToOrderChannel(accountNum, (data) => {
    //             if (data && data.order) {
    //                 //   if (data.order.current_price > 0) {
    //                 //     dispatch(removePosition(data.order.position_id));
    //                 //   } 
    //                 console.log('pending data', data);

    //                 if (data.order.type.startsWith("OP_") || data.order.position_id === 0) {
    //                     const newPosition = {
    //                         positionid: data.order.position_id,
    //                         symbol: data.order.symbol,
    //                         type: data.order.type,
    //                         volume: data.order.lot_size,
    //                         price: data.order.price,
    //                         //   commission: data.order.commission,
    //                         //   reason: data.order.reason,
    //                         profit: data.order.profit,
    //                         currentPrice: data.order.current_price,
    //                         sl: data.order.sl,
    //                         tp: data.order.tp,
    //                         //   open_time_formated: data.order.open_time,
    //                     };
    //                     dispatch(addPosition(newPosition));
    //                 }
    //             }
    //         });

    //         return () => {
    //             unsubscribeFromOrderChannel(accountNum); // Cleanup on unmount
    //         };
    //     }
    // }, [dispatch]);

    // useEffect(() => {
    //     const user = JSON.parse(localStorage.getItem('user'));
    //     const accountNum = user ? user.account : null;

    //     if (accountNum) {
    //         dispatch(fetchPendingOrders(accountNum));
    //         subscribeToOrderChannel(accountNum, (data) => {
    //             if (data && data.order) {
    //                 // data.order.type.startsWith("OP_") || data.order.position_id === 0
    //                 // data.order.current_price > 0
    //                 if (data.order.type.startsWith("OP_") || data.order.position_id === 0) {
    //                     const newPosition = {
    //                         positionid: data.order.position_id === 0 ? data.order.position_id + 1 : data.order.position_id,
    //                         symbol: data.order.symbol,
    //                         volume: data.order.lot_size,
    //                         type: data.order.type,
    //                         price: data.order.price,
    //                         commission: data.order.commission,
    //                         reason: data.order.reason,
    //                         profit: data.order.profit,
    //                         currentPrice: data.order.current_price,
    //                         sl: data.order.sl,
    //                         tp: data.order.tp,
    //                         open_time_formated: data.order.open_time,
    //                     };
    //                     dispatch(addPosition(newPosition));

    //                 } else {
    //                     dispatch(removePosition(data.order.position_id));
    //                 }
    //             }
    //         });

    //         return () => {
    //             unsubscribeFromOrderChannel(accountNum);
    //         };
    //     }
    // }, [dispatch]);


    useEffect(() => {
        if (successMessage) {
            setToastMessage(successMessage);
            setToastType('success');
            setToastVisible(true);
            setTimeout(() => setToastVisible(false), 3000); // Hide toast after 3 seconds
        } else if (errorMessage) {
            setToastMessage(errorMessage);
            setToastType('error');
            setToastVisible(true);
            setTimeout(() => setToastVisible(false), 3000); // Hide toast after 3 seconds
        } else if (tradeUpdationSuccessMessage) {
            setToastMessage(tradeUpdationSuccessMessage);
            setToastType('success');
            setToastVisible(true);
            setTimeout(() => setToastVisible(false), 3000); // Hide toast after 3 seconds
        }
    }, [successMessage, errorMessage, tradeUpdationSuccessMessage]);

    return (
        <div>
            <Card className='mb-0'>
                <CardBody className="p-0">
                    <Table className="text-center trading-t-table">
                        <thead className='bg-body'>
                            <tr>
                                <th>#</th>
                                <th>Position ID</th>
                                <th>Symbol</th>
                                <th>Type</th>
                                <th>Volume</th>
                                <th>Price</th>
                                <th>SL</th>
                                <th>TP</th>
                                <th>Swap</th>
                                <th>Profit</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="11" className="text-center">
                                        <Spinner size="sm" color="primary" /> Loading...
                                    </td>
                                </tr>
                            ) :
                                error ? (
                                    // Render error row if there's an error
                                    <tr>
                                        <td colSpan="11" className="text-center text-danger">
                                            {" Page you are looking for doesn't exit or an other error ocurred or temporarily unavailable."}
                                            {" Please try again."}
                                        </td>
                                    </tr>
                                ) :
                                    pendingOrders && pendingOrders?.length > 0 ? (

                                        pendingOrders?.map((order, index) => {
                                            const defaultSL = order.sl === 0 ? 0 : order.sl;
                                            const defaultTP = order.tp === 0 ? 0 : order.tp;
                                            const defaultPrice = order.price === 0 ? 0 : order.price;
                                            const orderType = order.type === "OP_BUY_LIMIT" ? 'BUY' : order.type === "OP_SELL_LIMIT" ? "SELL" : order.type;
                                            return (
                                                <tr className='opd-tr' key={order.positionid}>
                                                    <td>{index + 1}</td>
                                                    <td>{order.positionid ? order.positionid : index + 1}</td>
                                                    <td>{order.symbol}</td>
                                                    <td>
                                                        <span
                                                            className={`badge cursor-pointer ${orderType === 'SELL' ? 'bg-primary-subtle text-primary' : 'bg-secondary-subtle text-secondary'
                                                                }`}
                                                        >
                                                            {orderType}
                                                        </span>
                                                    </td>
                                                    <td
                                                        className={`${orderType === 'SELL' ? 'text-primary' : 'text-secondary'
                                                            }`}
                                                    >{order.volume}</td>
                                                    {/* PriceField */}
                                                    <td>
                                                        {editingField?.positionId === order.positionid && editingField?.field === 'price' ? (
                                                            <>
                                                                <input
                                                                    type="number"
                                                                    className="form-control py-0 px-1"
                                                                    value={editValue}
                                                                    onChange={(e) => setEditValue(e.target.value)}
                                                                    style={{ width: '80px', display: 'inline' }}
                                                                    autoFocus
                                                                />
                                                                <i
                                                                    className="ri-check-line text-success ms-2 cursor-pointer"
                                                                    onClick={() => handleUpdatePrice(order.positionid, editValue)}
                                                                ></i>
                                                                <i
                                                                    className="ri-close-line text-danger ms-2 cursor-pointer"
                                                                    onClick={handleCancelEdit}
                                                                ></i>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {defaultPrice === 0 ? order.price : defaultPrice}
                                                                <i
                                                                    className="ri-edit-line ms-2 cursor-pointer"
                                                                    onClick={() => handleEditStart(order.positionid, 'price', order.price)}
                                                                ></i>
                                                            </>
                                                        )}
                                                    </td>
                                                    {/* SL Field */}
                                                    <td>
                                                        {editingField?.positionId === order.positionid && editingField?.field === 'sl' ? (
                                                            <>
                                                                <input
                                                                    type="number"
                                                                    className="form-control py-0 px-1"
                                                                    value={editValue}
                                                                    onChange={(e) => setEditValue(e.target.value)}
                                                                    style={{ width: '80px', display: 'inline' }}
                                                                    autoFocus
                                                                />
                                                                <i
                                                                    className="ri-check-line text-success ms-2 cursor-pointer"
                                                                    onClick={() => handleUpdateSL(order.positionid, editValue)}
                                                                ></i>
                                                                <i
                                                                    className="ri-close-line text-danger ms-2 cursor-pointer"
                                                                    onClick={handleCancelEdit}
                                                                ></i>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {defaultSL === 0 ? '0' : defaultSL}
                                                                <i
                                                                    className="ri-edit-line ms-2 cursor-pointer"
                                                                    onClick={() => {
                                                                        const symbolData = symbols[order.symbol];
                                                                        const editValue = symbolData ? symbolData.ask : order.price; // Use ask price if available
                                                                        handleEditStart(order.positionid, 'sl', editValue);
                                                                    }}
                                                                ></i>
                                                            </>
                                                        )}
                                                    </td>

                                                    {/* TP Field */}
                                                    <td>
                                                        {editingField?.positionId === order.positionid && editingField?.field === 'tp' ? (
                                                            <>
                                                                <input
                                                                    type="number"
                                                                    className="form-control py-0 px-0"
                                                                    value={editValue}
                                                                    onChange={(e) => setEditValue(e.target.value)}
                                                                    style={{ width: '80px', display: 'inline' }}
                                                                    autoFocus
                                                                />
                                                                <i
                                                                    className="ri-check-line text-success ms-2 cursor-pointer"
                                                                    onClick={() => handleUpdateTP(order.positionid, editValue)}
                                                                ></i>
                                                                <i
                                                                    className="ri-close-line text-danger ms-2 cursor-pointer"
                                                                    onClick={handleCancelEdit}
                                                                ></i>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {defaultTP === 0 ? '0' : defaultTP}
                                                                <i
                                                                    className="ri-edit-line ms-2 cursor-pointer"
                                                                    onClick={() => {
                                                                        const symbolData = symbols[order.symbol];
                                                                        const editValue = symbolData ? symbolData.ask : order.price; // Use ask price if available
                                                                        handleEditStart(order.positionid, 'tp', editValue)
                                                                    }}
                                                                ></i>
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>{order.swap}</td>
                                                    <td>{order.profit}</td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span onClick={() => handleOrderCancel(order)}
                                                            className="bg-primary cursor-pointer"
                                                            style={{ color: "white", padding: "2px 3px", borderRadius: "50%", fontSize: "15px" }}>
                                                            <i className="ri-close-line"></i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="11" className="text-center">
                                                No pending orders available
                                            </td>
                                        </tr>
                                    )}
                        </tbody>
                    </Table>
                    {/* Toast Notification */}
                    {toastVisible && (
                        <div className="toast-container position-fixed bottom-0 end-0 p-3">
                            <Toast style={{ width: '250px' }} color={toastType === 'success' ? 'success' : 'danger'}>
                                <ToastHeader icon={toastType === 'success' ? 'success' : 'danger'}>
                                    {toastType === 'success' ? 'Success' : 'Error'}
                                </ToastHeader>
                                <ToastBody>
                                    {toastMessage}
                                </ToastBody>
                            </Toast>
                        </div>
                    )}
                </CardBody>
            </Card>


        </div>
    );
};

export default PendingOrders;
